$w.onReady(
function
() {
$w("#copyright").text = "© " +
new
Date().getFullYear().toString() ;
});
